import React, { useEffect, useState } from 'react'

import { performancePotentialTranslate } from '../../i18n/translatedMessages'

export function NineBox({ stars }) {
	const [coordinate, setCoordinate] = useState({
		cdPerformance: null,
		cdPotential: null,
	})

	const dataPotential = Number(stars.potential)
	const dataPerformance = Number(stars.performance)

	useEffect(() => {
		let cdPerformance = null
		let cdPotential = null

		if (dataPerformance >= 0.1 && dataPerformance <= 3) {
			cdPerformance = 0
		} else if (dataPerformance >= 3.1 && dataPerformance <= 4) {
			cdPerformance = 1
		} else if (dataPerformance >= 4.1) {
			cdPerformance = 2
		}

		if (dataPotential >= 0.1 && dataPotential <= 3) {
			cdPotential = 0
		} else if (dataPotential >= 3.1 && dataPotential <= 4) {
			cdPotential = 1
		} else if (dataPotential >= 4.1) {
			cdPotential = 2
		}

		setCoordinate({
			cdPerformance,
			cdPotential,
		})
	}, [dataPotential, dataPerformance])

	const getBoxDetails = () => {
		const key = `${coordinate.cdPerformance}-${coordinate.cdPotential}`

		const boxMapping = {
			'0-0': {
				title: performancePotentialTranslate.profile1,
				description: performancePotentialTranslate.nineBoxDesc7,
				style: 'tw-bg-[#FEE4E5]',
				border: '#891336',
			},
			'1-0': {
				title: performancePotentialTranslate.profile2,
				description: performancePotentialTranslate.nineBoxDesc8,
				style: 'tw-bg-[#DFF3FE]',
				border: '#084E72',
			},
			'2-0': {
				title: performancePotentialTranslate.profile3,
				description: performancePotentialTranslate.nineBoxDesc9,
				style: 'tw-bg-[#DFF3FE]',
				border: '#084E72',
			},
			'0-1': {
				title: performancePotentialTranslate.profile4,
				description: performancePotentialTranslate.nineBoxDesc4,
				style: 'tw-bg-[#FEF3C6]',
				border: '#793510',
			},
			'1-1': {
				title: performancePotentialTranslate.profile5,
				description: performancePotentialTranslate.nineBoxDesc5,
				style: 'tw-bg-[#DFF3FE]',
				border: '#084E72',
			},
			'2-1': {
				title: performancePotentialTranslate.profile6,
				description: performancePotentialTranslate.nineBoxDesc6,
				style: 'tw-bg-[#C7FFF1]',
				border: '#0D554A',
			},
			'0-2': {
				title: performancePotentialTranslate.profile7,
				description: performancePotentialTranslate.nineBoxDesc1,
				style: 'tw-bg-[#FEF3C6]',
				border: '#793510',
			},
			'1-2': {
				title: performancePotentialTranslate.profile9,
				description: performancePotentialTranslate.nineBoxDesc2,
				style: 'tw-bg-[#C7FFF1]',
				border: '#0D554A',
			},
			'2-2': {
				title: performancePotentialTranslate.profile8,
				description: performancePotentialTranslate.nineBoxDesc3,
				style: 'tw-bg-[#60fab2]',
				border: '#0D554A',
			},
		}

		return boxMapping[key] || null
	}

	const activeBox = getBoxDetails()

	if (!activeBox) {
		return (
			<div className='tw-flex tw-items-center tw-justify-center tw-p-8'>
				<div className='tw-p-8 tw-flex tw-items-center tw-justify-center border tw-max-w-sm tw-rounded-md'>
					{performancePotentialTranslate.empty9Box}
				</div>
			</div>
		)
	}

	return (
		<div className='tw-flex tw-items-center tw-justify-center'>
			<div
				className={`tw-h-full tw-max-w-sm tw-p-6 tw-rounded-lg tw-shadow ${activeBox.style}`}
				style={{ border: `1px solid ${activeBox.border}` }}
			>
				<h5 className='tw-mb-2 tw-font-bold'>{activeBox.title}</h5>
				<p className='tw-text-sm'>{activeBox.description}</p>
			</div>
		</div>
	)
}

export default NineBox
